<div class='wrapperCongratsForOfficialAfterAddNewGroup'>
  <img src='assets/bcgLogo/bcgLogo_textNotchGreen.svg' alt='notch' class='authLogo'>
  <div class='o-text4-blueDark o-flexCenter o-mg-t-35'>Congrats!
    <img src='assets/congrats_2.svg' alt='' class='o-mg-l-8'>
  </div>
  <div class='o-text6-blueDark o-mg-t-12 o-text-center'>
    You have been successfully added to the <span class='o-text5-blueDark o-text-center'>{{groupName}}</span> group!
  </div>
  <btn text='Go to Dashboard' bcg='newGreen' (click)='close()' class='o-mg-t-32'></btn>
</div>